import { Relationship } from "@/shared/constants/relationshipOptions";

import type { PersonContact } from "@/shared/types/estateContact";

const PROFESSIONAL_RELATIONSHIPS = new Set([
  Relationship.Attorney,
  Relationship.OtherProfessional,
  "financial-advisor",
]);

const PROFESSIONAL_LEGAL_ROLES = new Set(["attorney", "financial advisor"]);

function normalize(value: string): string {
  return value.toLowerCase().replace(/[\s_]/g, "-");
}

function hasLegalRole(contact: PersonContact, role: string): boolean {
  return contact.legal_role?.some((r) => r.toLowerCase() === role) ?? false;
}

export const isProfessionalContact = (contact: PersonContact): boolean => {
  const rel = contact.relationship ? normalize(contact.relationship) : "";
  return (
    PROFESSIONAL_RELATIONSHIPS.has(rel) ||
    (contact.legal_role?.some((r) => PROFESSIONAL_LEGAL_ROLES.has(r.toLowerCase())) ?? false)
  );
};

export const isAttorneyContact = (contact: PersonContact): boolean => {
  const rel = contact.relationship ? normalize(contact.relationship) : "";
  return rel === Relationship.Attorney || hasLegalRole(contact, "attorney");
};

export function getBannerDismissKey(hasAttorney: boolean): string {
  return hasAttorney ? "hide_invite_family_banner" : "hide_attorney_banner";
}
